var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from '@emotion/styled';
import { position, display, height, width, order } from 'styled-system';
import { ResponsiveLazyImage, } from '../../common/components/LazyImage';
import { BackgroundImage, } from '../../common/components/BackgroundImage';
import { Stoerer } from '../../common/components/Stoerer';
import { DisclaimerSubscription } from '../../common/event-bus/EventSubscription';
import LegalNotesLink from './LegalNotesLink';
var SlideBackgroundContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), position, width, height, order);
SlideBackgroundContainer.defaultProps = {
    position: 'relative',
    order: [1, 2],
};
var SLIDE_SECOND_HALF_WIDTHS = [1, '52%', null, '57%'];
var ImageContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), display, height);
ImageContainer.defaultProps = {
    height: [168, 220, 304, 394],
};
var Image = styled(BackgroundImage)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  opacity: ", ";\n  transition: opacity 0.3s ease-in-out;\n"], ["\n  opacity: ", ";\n  transition: opacity 0.3s ease-in-out;\n"])), function (_a) {
    var show = _a.show;
    return "" + Number(show);
});
Image.defaultProps = __assign(__assign({}, BackgroundImage.defaultProps), { backgroundSize: 'cover' });
var TopTeaserStoerer = styled(Stoerer)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
TopTeaserStoerer.defaultProps = __assign(__assign({}, Stoerer.defaultProps), { themeLeft: ['50%', '48%', null, '43%'], themeTop: [0, 3, '28px', '66px'] });
var onClickLegalNotes = function (_a) {
    var emit = _a.emit, html = _a.html;
    return function (event) {
        event.preventDefault();
        emit({ html: html, open: true });
    };
};
export var SlideBackground = function (_a) {
    var stoerer = _a.stoerer, imageProps = _a.image, legalDisclaimer = _a.legalDisclaimer, fullWidthImage = _a.fullWidthImage;
    return (React.createElement(SlideBackgroundContainer, { "data-testid": "right-side-slide", width: fullWidthImage ? '100%' : SLIDE_SECOND_HALF_WIDTHS },
        React.createElement(ImageContainer, { "data-testid": "image-container-slide" },
            stoerer && (React.createElement(TopTeaserStoerer, { label: stoerer.label, borderColor: stoerer.borderColor })),
            React.createElement(ResponsiveLazyImage, __assign({}, imageProps), function (_a) {
                var image = _a.image, thumbnail = _a.thumbnail, loaded = _a.loaded, intersected = _a.intersected, innerRef = _a.innerRef;
                return (React.createElement(Image, { "data-testid": "image", ref: innerRef, alt: imageProps.alt, show: intersected, src: loaded ? image : thumbnail }));
            })),
        legalDisclaimer && (React.createElement(DisclaimerSubscription, null, function (_a) {
            var emit = _a.emit;
            var linkLabel = legalDisclaimer.linkLabel, linkLabelColor = legalDisclaimer.linkLabelColor, contentHtml = legalDisclaimer.contentHtml;
            return (React.createElement(LegalNotesLink, { linkLabel: linkLabel, linkLabelColor: linkLabelColor, onClick: onClickLegalNotes({
                    emit: emit,
                    html: contentHtml,
                }) }));
        }))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
